import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import Messages from "./translations/UssdSystem.json";
import { Icon } from "@iconify/react";
// import Messages from "./translations/Secure.json";
import { useLangContext } from "../../components/translateContext";
// import buttonText from "../../translations/button.json";
export default function UssdSystem() {
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang] };
  return (
    <Wrapper childrenClassName="mb-20 relative" className="bg-white md:pb-6">
      <div className="relative  flex mb-8 align-center justify-center   text-center  ">
        <div>
          <p className="text-qosblackText font-bold md:leading-40 md:text-Nw2  md:pt-24 ">
            {" "}
            {Infos.msg.HelloText}
          </p>
          <p className="text-qosblackgray font-normal md:text-Mobilw22 mt-2  my-2 md:mt-0 w-full md:px-20  md:py-4 ">
            {Infos.msg.description}
          </p>
        </div>
      </div>
      <div className="w-full">
        <div className="w-full h-full">
          <img src={media.Logos.Ussd.ussdOptions} alt="" className="" />
        </div>
      </div>
    </Wrapper>
  );
}
